import React from "react";
import styled from "styled-components";
import { Button } from "./reusable_components";

const CardBody = styled.div`
  width: 570px;
  min-height: 200px;
  margin: 10px;
  padding: 10px 20px;
  border-radius: 15px;
  border-top: 5px solid #693b93;
  border-bottom: 1px solid #693b93;
  border-left: 1px solid #693b93;
  border-right: 1px solid #693b93;
  background: linear-gradient(
    149.88deg,
    #130428 37.22%,
    #251043 70.43%,
    #38126d 97.89%,
    #261045 132.38%,
    #190634 150.9%
  );
  @media (max-width: 770px) {
    flex-direction: column;
    width: 100%;
  }
`;
const ImageBox = styled.div`
  width: 300px;
  height: 160px;
  background-image: url(${(props) => props.data});
  background-size: cover;
  background-position: center;
  position: relative;
  ::before {
    content: "";
    width: 100%;
    height: 100px;
    border-radius: 100%;
    background: linear-gradient(
      180deg,
      #2c1250 0%,
      #2c1250 19.79%,
      rgba(44, 18, 80, 0) 90.1%
    );
    -webkit-transform: rotateX(133deg);
    -ms-transform: rotateX(133deg);
    transform: rotateX(133deg);
    position: absolute;
    bottom: -18%;
    border-radius: 60%;
    left: 0;
  }
`;
const Heading = styled.h2`
  color: #fff;
  font-family: sans-serif;
`;
const SubHeader = styled.p`
  color: #fff;
  font-family: sans-serif;
`;
const Cards = ({ data }) => {
  return (
    <CardBody
      className="d-flex justify-around align-center"
      data-aos={data.Aos}
    >
      <ImageBox data={data.Image} />
      <div className="card_content_box">
        <Heading>{data.Position}</Heading>
        <SubHeader>{data.desc}</SubHeader>
        <Button value={"Learn more"} link={data.link} rel="noreferrer" />
      </div>
    </CardBody>
  );
};

export default Cards;
